import request from '@/utils/request'

const tradePaymentAttachmentApi = {
  trade_payment_attachment_list: '/trade/payment_attachment/',
  trade_payment_attachment_create: '/trade/payment_attachment/',
  trade_payment_attachment_update: '/trade/payment_attachment/',
  trade_payment_attachment_delete: '/trade/payment_attachment/',
  trade_payment_application_attachment_list: '/trade/payment_application_attachment/',
  trade_payment_application_attachment_create: '/trade/payment_application_attachment/',
  trade_payment_application_attachment_update: '/trade/payment_application_attachment/',
  trade_payment_application_attachment_delete: '/trade/payment_application_attachment/'
}

/**
 * 列表
 */
export function payment_attachment_list (parameter) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function payment_attachment_create (parameter) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function payment_attachment_update (parameter, payment_attachment_id) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_attachment_update + payment_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function payment_attachment_delete (payment_attachment_id) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_attachment_delete + payment_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function payment_application_attachment_list (parameter) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_application_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function payment_application_attachment_create (parameter) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_application_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function payment_application_attachment_update (parameter, payment_attachment_id) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_application_attachment_update + payment_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function payment_application_attachment_delete (payment_attachment_id) {
  return request({
    url: tradePaymentAttachmentApi.trade_payment_application_attachment_delete + payment_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
